export default __webpack_public_path__ + "static/zenith-3-559d8ce8782a593a9944688dbea2c8f9.jpg";